export const arrayStatus = [
  {
    id: 24,
    name: 'nuevo',
    key: 'new_route',
  },
  {
    id: 25,
    name: 'en_ruta',
    key: 'in_route',
  },
  {
    id: 26,
    name: 'completado',
    key: 'completed_route',
  },
  {
    id: 35,
    name: 'interrumpido',
    key: 'interrupted_route',
  },
]

export const objectStatusRoutes = {
  24: {
    id: 24,
    name: 'nuevo',
    key: 'new_route',
  },
  25: {
    id: 25,
    name: 'en_ruta',
    key: 'in_route',
  },
  26: {
    id: 26,
    name: 'completado',
    key: 'completed_route',
  },
  35: {
    id: 35,
    name: 'interrumpido',
    key: 'interrupted_route',
  },
}

export const fnObjNameStatus = () => {
  const obj = {}
  arrayStatus.forEach((item) => (obj[item.name] = item.id))
  return obj
}
